import { useState } from "react";
import axios from "axios";

function Comment() {
    let randString = "";
    const alphaNum = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for (let i = 0; i < 6; i++)
    {
        randString += alphaNum[Math.floor(Math.random()*62)];
    }

    const [buttonDisabled,setDisabled] = useState(true);
    const [randomString] = useState(randString);
    const [formHidden,setFormHidden] = useState(false);

    const [formData,setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        comments: ""
    });

    function verifyForm()
    {
        if( randomString === document.getElementById("verify").value ) {
            setDisabled(false);
        }
        else setDisabled(true);
    }

    function handleSubmit(event)
    {
        event.preventDefault();
        setFormData({
            firstName: document.getElementById("firstName").value,
            lastName: document.getElementById("lastName").value,
            email: document.getElementById("email").value,
            comments: document.getElementById("comments").value
        });
        if(document.getElementById("email").value !== "" || document.getElementById("comments").value !== "")
        {
            axios.post(
                "https://clients.freese.com/FNIEmailAPI/api/Email/SendEmail",
                {
                    To: ["egc@freese.com"],
                    Bcc: ["webmaster@freese.com"],
                    From: ( (document.getElementById("email").value === "") ? "webmaster@freese.com" : document.getElementById("email").value ),
                    Subject: "City of Kilgore Comprehensive Plan website response",
                    Body: ( (document.getElementById("firstName").value !== "" || document.getElementById("lastName").value !== "") ?
                        ("Name:  " + document.getElementById("firstName").value +  " " + document.getElementById("lastName").value + "\n") :
                        "") +
                        ( (document.getElementById("email").value !== "" && document.getElementById("email").value !== "webmaster@freese.com") ?
                        ("E-mail:  " + document.getElementById("email").value) + "\n" : "" ) +
                        "Idea/Comments:  " + ( document.getElementById("comments").value === "" ? "Request to be included in future notices such as public meetings or additional online surveys." :
                        document.getElementById("comments").value )
                },
                {
                    headers: { 'XApiKey': 'UqjuU1u9HmRoaXvX0GxTm' }
                }
            ).then(res => console.log(res))
            .catch(error => console.log(error));
        }
        setFormHidden(true);
    }

    const tableStyle = {
        width: "100%",
        border: "0",
        cellspacing: "0",
        cellpadding: "2",
        marginTop: "40px"
    }
    return (
        <div className="container" style={{marginTop: "100px", marginBottom: "20px" }}>
            <br/>
            <div style={{ display: (formHidden ? "none" : "") }}>
                <h2>Submit a Comment</h2>
                <form onSubmit={e => handleSubmit(e) }>
                    <table style={tableStyle}>
                        <tbody>
                            <tr valign="top">
                                <td align="left"><p>Your Idea/Comment:</p></td>
                                <td><textarea className="form-control" name="comments" id="comments" cols="50" rows ="5"></textarea></td>
                            </tr>
                            <tr><td colSpan="2">&nbsp;</td></tr>
                            <tr>
                                <td colSpan="2">
                                    <p>If you would like to be notified about any public meetings or additional online surveys related to the
                                    <b> <i>City of Kilgore Comprehensive Plan Update</i></b>, please enter your name and email address in the spaces below. 
                                    (You only have to provide this information once.)</p>
                                </td>
                            </tr>
                            <tr><td colSpan="2">&nbsp;</td></tr>

                            <tr valign="top">
                                <td width="25%" align="left"><p>First Name:</p></td>
                                <td width="75%">
                                    <input type="text" name="firstName" id="firstName" size="30" className="form-control"/>
                                </td>
                            </tr>

                            <tr valign="top">
                                <td align="left"><p>Last Name:</p></td>
                                <td>
                                    <input type="text" name="lastName" id="lastName" size="30" className="form-control"/>
                                </td>
                            </tr>

                            <tr valign="top">
                                <td align="left"><p>E-mail:</p></td>
                                <td>
                                    <input type="email" name="email" id="email" size="30" className="form-control"/>
                                </td>
                            </tr>

                            <tr valign="top">
                                <td align="left"><p>* Please type the code below:</p>
                                                <fieldset>
                                                    <strong><center>{randomString}</center></strong>
                                                </fieldset>
                                </td>
                                <td>
                                    <input type="text" name="verify" id="verify" required className="form-control" onChange={verifyForm}/>
                                </td>
                            </tr>
                            <tr valign="top"><td align="right">&nbsp;</td></tr>
                        </tbody>
                    </table>
                    <div align="center">
                        <input type="reset" name="Reset" value="Reset" className="btn" style={{ marginRight: "20px", backgroundColor: "#073553", color: "white" }}/>
                        <input type="submit" name="Submit" value="Submit" className="btn" style={{ backgroundColor: "#073553", color: "white" }} disabled={buttonDisabled}/>
                    </div>
                </form>
            </div>

            <div className="container" style={{ display: (formHidden ? "" : "none") }}>
		        <p>
                    You have submitted the following:<br/><br/>
                    Idea/Comments: { formData.comments === ""  ? "Request to be included in future notices such as public meetings or additional online surveys." :
                    formData.comments }<br/><br/>
                    { formData.firstName === "" ? "" : ("First name:  " + formData.firstName) }<br/>
                    { formData.lastName === "" ? "" : ("Last name:  " + formData.lastName) }<br/>
                    { formData.email === "" ? "" : ("Email:  " + formData.email) }
                </p>
            </div>
        </div>
    );
};

export default Comment;